export const PERSONA_PAGE_ACTION_TYPES = {
  SET_INCOME: "SET_INCOME",
  SET_PROVINCE: "SET_PROVINCE",
  SET_LAWYER: "SET_LAWYER",
  SET_LOCATION_TYPE: "SET_LOCATION_TYPE",
  SET_MODAL: "SET_MODAL",
  RESET_CHOICES: "RESET_CHOICES"
};



// WEBPACK FOOTER //
// ./src/scenes/persona-page/store/persona-page.constants.js